export default __webpack_public_path__ + "8e3a439465dc9033837f6290b06742cc.png";